import styled, { css } from 'styled-components';
import { playGrey10 } from '../design-tokens';
import { PlayLinkContainer } from '../../components/Link';
import { device } from '../breakpoints';
import { Heading as BigImageHeading } from './components/Caption/Caption.styles';
import { regularOutline } from '../typography/helpers';

export const cssBigImage = css`
    display: block;
    width: 100%;
    background: ${playGrey10};
    margin: 0 0 5px;

    @media ${device.GteXLarge} {
        margin: 0 0 7px;
    }
`;
export const StyledBigImage = styled.article`
    ${cssBigImage}
`;

export const DisplayWindowLink = styled(PlayLinkContainer)`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    text-decoration: none;
    cursor: pointer;

    &:focus {
        ${regularOutline(2)}
    }

    &:active {
        outline: 0;
    }

    @media ${device.GteMedium} {
        display: flex;
        flex: 0 1 auto;
    }

    &:hover ${BigImageHeading} {
        text-decoration: underline;
    }
`;

export const imageContainerCss = css`
    width: 100%;

    @media ${device.GteMedium} {
        float: left;

        width: calc(((100% / 4) * 2) - 4px);

        .touchevents & {
            width: calc((100% / 1.4) - 15px);
        }
    }

    @media ${device.GteXLarge} {
        width: calc(((100% / 5) * 3) - 4px);
    }

    @media ${device.FullScreen} {
        width: calc(((100% / 6) * 4) - 4px);

        .touchevents & {
            width: 57.5%;
        }
    }
`;

export const ImageContainer = styled.div`
    ${imageContainerCss}
`;
